import { formatDocument } from "./document-format.js";
import { formatPhone } from "./phone-format.js";
const joined = (parts, separator) => parts.filter((part) => part !== null && part.trim() !== '').join(separator);
export const companyHeaderFrom = (company, fallbackName) => {
    if (company === undefined) {
        return { name: fallbackName, document: null, addressLine: null };
    }
    const street = joined([company.fiscal.street, company.fiscal.streetNumber], ', ');
    const city = joined([company.fiscal.city, company.fiscal.state], '/');
    const addressLine = joined([street, company.fiscal.district, city], ' — ');
    const postal = company.fiscal.postalCode;
    return {
        name: company.tradeName ?? company.legalName,
        document: formatDocument(company.cnpj),
        addressLine: addressLine === '' ? null : addressLine,
        legalName: company.legalName,
        postalCode: postal === null || postal.trim() === ''
            ? null
            : postal.replace(/^(\d{5})(\d{3})$/, '$1-$2'),
        phone: company.fiscal.phone === null || company.fiscal.phone.trim() === ''
            ? null
            : formatPhone(company.fiscal.phone),
        stateRegistration: company.fiscal.stateRegistration,
    };
};
//# sourceMappingURL=company-header.js.map